// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BaseExtLink } from './BaseExtLink';
import { BrandingToolLinkGenerator } from './Branding/BrandingToolLinkGenerator';
export class NoneExtLink extends BaseExtLink {
    generateUrl() {
        var _a;
        const url = BrandingToolLinkGenerator.generateLinkNoneURL(this);
        if (url) {
            this.url = url;
            (_a = this.updateValue) === null || _a === void 0 ? void 0 : _a.call(this, url);
        }
    }
}
